import {Fragment, React} from '@api'
import * as css from './SkeletonGlowEvent.css'

export const SkeletonGlowEvent = () => {
  return (
    <Fragment>
      <div className={css.skeletonGlow}/>
      <div className={css.skeleton}>
        <div className={css.userIconWrapper}>
          <div className={css.userIcon}/>
        </div>
        <div className={css.details}/>
      </div>
    </Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/CatalogItemChangeHistory/SkeletonGlowEvent.tsx